<template>
  <v-dialog :value="true" width="50%" persistent>
    <v-card>
      <v-card-title primary-title>
        <div>
          <div class="title">Add a member</div>
        </div>
        <v-spacer></v-spacer>
        <v-btn
          small
          dark
          icon
          color="grey"
          @click="$emit('close')"
          class="mx-0"
        >
          <v-icon small>$vuetify.icons.rms_close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" onsubmit="return false;">
          <v-text-field
            v-model="email"
            :rules="[rules.required, rules.email]"
            color="primary"
            :label="$t('rms.field.email.label')"
          ></v-text-field>
          <v-text-field
            v-model="name"
            :rules="[rules.required]"
            color="primary"
            :label="$t('rms.field.name.label')"
          ></v-text-field>
          <v-select
            v-model="role"
            color="primary"
            :items="DEFINES.COMPANY_USER_ROLE"
            :rules="[rules.required]"
            item-text="text"
            item-value="value"
            :label="$t('rms.field.role.label')"
          ></v-select>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="lightteal" flat outline @click="addMember">{{
          $t('rms.button.add')
        }}</v-btn>
        <v-btn color="grey" flat outline @click="$emit('close')">{{
          $t('rms.button.cancel')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import rules from '@/validation';
import i18n from '@/i18n';
import {mapState, mapGetters} from 'vuex';
import DEFINES from '@/defines';
export default {
  props: ['show_dialog'],
  name: 'AddMemberDialog',
  data() {
    return {
      rules,
      email: null,
      name: '',
      role: null,
      roles: [
        {
          text: 'Owner',
          value: DEFINES.ROLE_OWNER,
        },
        {
          text: 'Member',
          value: DEFINES.ROLE_MEMBER,
        },
      ],
    };
  },
  computed: {
    ...mapGetters('company', {
      selected_company_id: 'getSelected',
    }),
  },

  methods: {
    async addMember(payload) {
      try {
        if (!this.$refs.form.validate()) {
          return false;
        }
        var data = await this.$store.dispatch('company/addMember', {
          id: this.selected_company_id,
          email: this.email,
          name: this.name,
          role: this.role,
        });
        this.$emit('memberAdded')
        this.$store.dispatch('app/showMessage', {
          message: i18n.t('message.success.member_added'),
          color: 'success',
        });
        this.$emit('close');
      } catch (error) {
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: 'error',
        });
      }
    },
  },
};
</script>
